import React from 'react';
import PropTypes from 'prop-types';

export const QuickTransfer = ({ width , height , ...props }) => (
  <svg
    data-icon='quick-transfer'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 32 32'
    { ...props }
  >
    <g
      clipPath='url(#a)'
      data-figma-skip-parse='true'
    >
      <foreignObject
        width={ 2838.54 }
        height={ 2838.54 }
        x={ -1419.27 }
        y={ -1419.27 }
        transform='matrix(-.013 .01075 -.01075 -.013 16 16)'
      >
        <div
          xmlns='http://www.w3.org/1999/xhtml'
          style={{
            background:
              'conic-gradient(from 90deg,#ffd72d 0deg,#ff9d3c 44.5849deg,#ff2d11 106.417deg,#9030ff 171.287deg,#3060ff 225.019deg,#7bed7b 278.972deg,#fff027 340.296deg,#ffd72d 360deg)',
            height: '100%',
            width: '100%',
            opacity: 1,
          }}
        />
      </foreignObject>
    </g>
    <path
      d='M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm0-8.649a7.351 7.351 0 1 0 0-14.703 7.351 7.351 0 0 0 0 14.703Z'
      clipRule='evenodd'
      data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":1.0,"g":0.61778819561004639,"b":0.2355763316154480,"a":1.0},"position":0.12384695559740067},{"color":{"r":1.0,"g":0.17753705382347107,"b":0.068909868597984314,"a":1.0},"position":0.29560220241546631},{"color":{"r":0.56837594509124756,"g":0.19070492684841156,"b":1.0,"a":1.0},"position":0.47579818964004517},{"color":{"r":0.19070492684841156,"g":0.37954044342041016,"b":1.0,"a":1.0},"position":0.62505179643630981},{"color":{"r":0.48494210839271545,"g":0.93108952045440674,"b":0.48494210839271545,"a":1.0},"position":0.77492189407348633},{"color":{"r":1.0,"g":0.94369655847549438,"b":0.15544833242893219,"a":1.0},"position":0.94526737928390503}],"stopsVar":[{"color":{"r":1.0,"g":0.61778819561004639,"b":0.2355763316154480,"a":1.0},"position":0.12384695559740067},{"color":{"r":1.0,"g":0.17753705382347107,"b":0.068909868597984314,"a":1.0},"position":0.29560220241546631},{"color":{"r":0.56837594509124756,"g":0.19070492684841156,"b":1.0,"a":1.0},"position":0.47579818964004517},{"color":{"r":0.19070492684841156,"g":0.37954044342041016,"b":1.0,"a":1.0},"position":0.62505179643630981},{"color":{"r":0.48494210839271545,"g":0.93108952045440674,"b":0.48494210839271545,"a":1.0},"position":0.77492189407348633},{"color":{"r":1.0,"g":0.94369655847549438,"b":0.15544833242893219,"a":1.0},"position":0.94526737928390503}],"transform":{"m00":-25.983478546142578,"m01":-21.506299972534180,"m02":39.744888305664062,"m10":21.506299972534180,"m11":-25.983478546142578,"m12":18.238590240478516},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    />
    <defs>
      <clipPath id='a'>
        <path
          fillRule='evenodd'
          d='M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm0-8.649a7.351 7.351 0 1 0 0-14.703 7.351 7.351 0 0 0 0 14.703Z'
          clipRule='evenodd'
        />
      </clipPath>
    </defs>
  </svg>
);

QuickTransfer.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

QuickTransfer.defaultProps = {
  width: 32,
  height: 32,
};
